/*global $*/
/*eslint no-undef: "error"*/
export default class Faq {
    classBlock = 'faq--block'
    classButton = 'faq--button'

    classBlockOpen = 'faq-open'

    constructor () {
        let self = this

        $(`.${self.classButton}`).click(function () {
            $(this).closest(`.${self.classBlock}`).toggleClass(self.classBlockOpen)
        })
    }
}
